import { Link } from "react-router";
import { usePlatforms } from "~/api/platforms";

// The companion to PlatformDetail's blueprint link: given a blueprint, show
// which registered platforms point at it, so an operator can navigate
// blueprint → platform, not just platform → blueprint. The platformSlug is the
// bare Platform slug, the same form platform.slug stores (ADR-0056).
export function LinkedPlatforms({ platformSlug }: { platformSlug: string }) {
  const { data: platforms = [] } = usePlatforms();
  const linked = platforms.filter((p) => p.slug === platformSlug);

  if (linked.length === 0) {
    return (
      <p className="bf-small" style={{ color: "var(--bfc-base-c-2)" }}>
        No platform is linked to this blueprint.
      </p>
    );
  }

  return (
    <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
      {linked.map((p) => (
        <li key={p.id}>
          <Link className="bf-link" to={`/platforms/${p.id}`}>
            {p.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
